import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Text,
  Icon,
  IconButton,
  Badge,
  ListGroup,
  ListGroupItem,
  WithTooltip
} from '@albert-io/atomic';
import {Link as RouterLink} from 'react-router';
import {getModelForResourceType} from 'resources/modelRegistry';
import {sendEmailInvites} from 'client/SchoolAdministration/School/ManageStaff/Staff/UpdateTeachers/updateTeachers.utils';

import 'client/SchoolAdministration/School/ManageStaff/Staff/UpdateTeachers/update-teachers.scss';

const AddTeachers = ({emailMatches, newEmails, params, rejectedTeachers}) => {
  const totalEmails = [...newEmails, ...emailMatches];

  return (
    <Card paddingLevel={3} shadow='far' className='update-teachers__email-table'>
      {totalEmails.length ? (
        <>
          <ListGroup>
            {Object.values(totalEmails).map((email, i) => (
              <ListGroupItem key={email} paddingLevel={1}>
                {newEmails.includes(email) ? (
                  <>
                    <Text>{`${i + 1}. ${email}`}</Text>
                    <Badge size='small' color='emphasized' className='u-mar-l_2'>
                      New teacher - Invitation will be sent
                    </Badge>
                  </>
                ) : (
                  `${i + 1}. ${email}`
                )}
              </ListGroupItem>
            ))}
          </ListGroup>
          {!newEmails.length ? (
            <>
              <div className='u-text-align_right u-display_flex u-align-items_center u-mar-t_4'>
                <Text
                  className='u-mar-r_2 u-mar-l_auto u-max-width_48ch u-display_flex u-align-items_center'
                  emphasis='low'
                  size='medium'
                >
                  <Icon icon='exclamation-triangle' className='u-mar-r_1' />
                  No invitations to send.
                  <WithTooltip
                    content='The emails above have already been added to your teacher list.'
                    display='flex'
                  >
                    <IconButton icon={['far', 'question-circle']} />
                  </WithTooltip>
                </Text>
                <Button disabled>
                  <Icon icon={['far', 'paper-plane']} className='u-mar-r_1' />
                  Send Teacher Invites
                </Button>
              </div>
            </>
          ) : (
            <div className='u-text-align_right'>
              <Button
                as={RouterLink}
                to={`/school-admin/${params.schoolId}/manage-staff`}
                className='u-mar-t_4'
                onClick={() =>
                  sendEmailInvites({newEmails, schoolId: params.schoolId, rejectedTeachers})
                }
              >
                <Icon icon={['far', 'paper-plane']} className='u-mar-r_1' />
                Send Teacher Invites
              </Button>
            </div>
          )}
        </>
      ) : (
        <div className='u-text-align_right'>
          <Text
            as='div'
            size='xl'
            emphasis='disabled'
            className='u-display_flex u-flex-direction_column u-align-items_center u-mar-t_4 u-mar-b_2'
          >
            <Icon
              size='inherit'
              icon={['fal', 'exclamation-circle']}
              className='update-teachers__info-icon u-mar-r_2 u-mar-t_4 u-mar-b_1 u-color_slate-400 u-mar-lr_auto u-display_block'
            />
            <Text as='div' className='u-mar-b_4 u-mar-l_4 u-text-align_center u-color_slate-500'>
              No teachers to add. The emails you provided already belong to administrator accounts.
              Admins cannot be added or removed during this process.
            </Text>
          </Text>
          <Button disabled>
            <Icon icon={['far', 'paper-plane']} className='u-mar-r_1' />
            Send Teacher Invites
          </Button>
        </div>
      )}
    </Card>
  );
};

AddTeachers.propTypes = {
  emailMatches: PropTypes.array,
  newEmails: PropTypes.array,
  params: PropTypes.object,
  rejectedTeachers: PropTypes.instanceOf(getModelForResourceType('school_v5'))
};

export default AddTeachers;
